export class Cookies {
  cookieName = 'confirmCookie';
  cookieExpiryDays = 7;
  showClass = 'show';
  hideClass = 'hide';

  cookiesContainer;
  confirmButton;
  checkbox;

  init() {
    this.cookiesContainer = document.querySelector('.cookies');
    if (!this.cookiesContainer) return;

    if (this.getCookie(this.cookieName)) {
      this.cookiesContainer.remove();
      return;
    }

    this.confirmButton =
      this.cookiesContainer.querySelector('.cookies__button');

    this.checkbox =
      this.cookiesContainer.querySelector('.cookies__checkbox');

    this.setupCheckboxLogic();
    this.showCookies();

    if (this.confirmButton) {
      this.confirmButton.addEventListener('click', () => {
        this.confirmCookie();
      });
    }
  }

  setupCheckboxLogic() {
    if (!this.checkbox || !this.confirmButton) return;

    this.confirmButton.disabled = !this.checkbox.checked;

    this.checkbox.addEventListener('change', () => {
      this.confirmButton.disabled = !this.checkbox.checked;
    });
  }

  showCookies() {
    setTimeout(() => {
      this.cookiesContainer.classList.add(this.showClass);
    }, 1000);
  }

  hideCookies() {
    this.cookiesContainer.classList.remove(this.showClass);
    this.cookiesContainer.classList.add(this.hideClass);

    setTimeout(() => {
      this.cookiesContainer.remove();
    }, 300);
  }

  confirmCookie() {
    this.hideCookies();
    this.setCookie(this.cookieName, 'true', this.cookieExpiryDays);
  }

  setCookie(name, value, days) {
    const date = new Date();

    date.setDate(date.getDate() + days);

    document.cookie =
      `${name}=${value}; expires=${date.toUTCString()}; path=/`;
  }

  getCookie(name) {
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');

      if (key === name) return value;
    }

    return null;
  }
}
